import { FC, useState } from 'react';
import AmplienceMegaNav, { AmplienceMegaNavProps } from './components/mega-nav';

export interface AmplienceHeaderNavProps {
  megaNavs: AmplienceMegaNavProps[];
}

const AmplienceHeaderNav: FC<AmplienceHeaderNavProps> = ({ megaNavs }) => {
  const [expandedNavIndex, setExpandedNavIndex] = useState(-1);

  return (
    <section className="relative z-[9] w-full px-6">
      <nav className="mx-auto w-full max-w-desktop">
        <ul className="hidden lg:flex">
          {megaNavs?.map((megaNav, index) => (
            <AmplienceMegaNav
              key={`mega-nav-${megaNav.title}-item-${index}`}
              {...megaNav}
              isExpanded={index === expandedNavIndex}
              onExpand={() => setExpandedNavIndex(index)}
              onCollapse={() => setExpandedNavIndex(-1)}
            />
          ))}
        </ul>
      </nav>
    </section>
  );
};

export default AmplienceHeaderNav;
